// extracted by mini-css-extract-plugin
export default {"dropdownIndicator":"Select_dropdownIndicator__-A+qW"};